module.exports = __webpack_public_path__ + "img/loading.474d538d.svg";